import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from 'recharts';
import { Card, EmptyState } from './Card.js';
import { fmtMonth, fmtPct, monthlyReturns } from '../utils.js';
import { bySign, GRID, AXIS, TOOLTIP_PROPS, PCT_AXIS_WIDTH, pctAxisDomain } from '../chartTheme.js';
import { fromMonth, type ReturnsFrom } from '../returnsFrom.js';
import type { PerformanceRow } from '@agio/core';

/** Monthly portfolio return bars (green/red). Shows the trailing 24 months, none before the client's "from" month. */
export function MonthlyReturnsChart({ perf, from = null }: { perf: PerformanceRow[]; from?: ReturnsFrom }) {
  const extracted = fromMonth(perf, from).filter((p) => p.monthly_return !== null);
  const source =
    extracted.length >= 2
      ? extracted.map((p) => ({ date: p.date, ret: p.monthly_return as number }))
      : fromMonth(monthlyReturns(perf), from).filter((r) => r.ret !== null).map((r) => ({ date: r.date, ret: r.ret as number }));
  const data = source.slice(-24);
  if (data.length === 0) return <Card title="תשואה חודשית"><EmptyState label="אין נתונים" /></Card>;

  return (
    <Card title="תשואה חודשית">
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data}>
          <CartesianGrid {...GRID} />
          <XAxis dataKey="date" tickFormatter={fmtMonth} {...AXIS} />
          <YAxis tickFormatter={(v: number) => fmtPct(v, 0)} {...AXIS} width={PCT_AXIS_WIDTH} orientation="right" domain={pctAxisDomain(data.map((d) => d.ret))} />
          <Tooltip
            {...TOOLTIP_PROPS}
            formatter={(v: number) => [fmtPct(v), 'תשואה']}
            labelFormatter={fmtMonth}
          />
          <Bar dataKey="ret" radius={[4, 4, 0, 0]}>
            {data.map((d) => (
              <Cell key={d.date} fill={bySign(d.ret)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}
